export default __webpack_public_path__ + "static/digiSystem-ba9ae357989a5444a7f1e926a6c648a2.png";